"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderLinesForProductSearchResponse = void 0;
const common_1 = require("../../common");
const sales_order_lines_for_product_data_response_1 = require("./sales-order-lines-for-product-data.response");
class SalesOrderLinesForProductSearchResponse extends common_1.PaginatedResponse {
}
exports.SalesOrderLinesForProductSearchResponse = SalesOrderLinesForProductSearchResponse;
//# sourceMappingURL=sales-order-lines-for-product-search.response.js.map